import {
  createAppReducerSimpleFetch,
  createAppReducerSimpleSubmit,
} from "shared/redux-store/defaults";
import reduceReducers from "reduce-reducers";

const orderCreationDataReducerFetch = createAppReducerSimpleFetch(
  "ORDER_CREATION",
  ["orderUnits", "products"],
);

const orderCreationAppReducerSubmit =
  createAppReducerSimpleSubmit("ORDER_CREATION");

export default reduceReducers(
  orderCreationDataReducerFetch,
  orderCreationAppReducerSubmit,
);
